// 材料中心
const offlineMaterial = {
  state: {
    areaList: [], // 地域数据
    areaOrgCode: '', // 选中地域code
    areaOrgName: '', // 选中地域name

    treeData: [], // 轮次届次单位树
    treeRowOid: '', // 树的行oid
    screenStart: true, // 是否开屏模式
    treeSelect: '' // 左边选择的内容
  },
  mutations: {
    setAreaList(state, value) {
      state.areaList = value
    },
    setAreaOrgCode(state, value) {
      state.areaOrgCode = value
    },
    setAreaOrgName(state, value) {
      state.areaOrgName = value
    },
    setTreeData(state, value) {
      state.treeData = value
    },
    setTreeRowOid(state, value) {
      state.treeRowOid = value
    },
    setScreenStart(state, value) {
      state.screenStart = value
    },
    setTreeRowSelect(state, value) {
      state.treeSelect = value
    },
  }
};
export default offlineMaterial;



// WEBPACK FOOTER //
// ./src/store/modules/offlineMaterial.js